import { Drawer, Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Drawer as DrawerType } from "../../../../hooks/drawer/useGenericDrawer";
import { DisplayLicenseDetails } from "../../DisplayLicenseDetails";
import { useEffect, useState } from "react";
import { MelcoModelsUserSerialNumber } from "melco-shared-logic";
import { useLicense } from "../../../../hooks/licenses/useLicense";
import { ValueOrFallback } from "../../../table/ValueOrFallback";
import styled from "styled-components";

type DetailsLicenseDrawerProps = {
  drawer: DrawerType;
  licenseId: string | undefined;
  onCloseCallBackFn: () => void;
};

const TitleWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 30px;
`;

export const DetailsLicenseDrawer: React.FC<DetailsLicenseDrawerProps> = ({
  licenseId,
  drawer,
  onCloseCallBackFn,
}) => {
  const { t } = useTranslation();

  const { isDrawerOpen } = drawer;

  const [license, setLicense] = useState<
    MelcoModelsUserSerialNumber | undefined
  >();
  const { data } = useLicense(licenseId);

  useEffect(() => {
    setLicense(data);
  }, [data]);

  return (
    <Drawer
      title={t("licenses.basic.detail.form.title.licenseDetails")}
      placement="right"
      width={1195}
      closable={true}
      onClose={onCloseCallBackFn}
      open={isDrawerOpen}
      bodyStyle={{ padding: "32px" }}
    >
      {isDrawerOpen && (
        <>
          <TitleWrapper>
            <Title level={5}> {t("main_menu.licenses")}</Title>
            <Title level={3}>
              <ValueOrFallback
                value={license?.serial_number}
                fallback={t("global.fallback.empty")}
              />
            </Title>
          </TitleWrapper>
          <DisplayLicenseDetails license={license} />
        </>
      )}
    </Drawer>
  );
};
